export default "__VITE_ASSET__BphtEMr8__"